import React from "react";
import { Button } from "../About/style";
import { Container, Desc, Title, Wrapper } from "./style";
const Skills = () => {
  return (
    <Container>
      <Container title reveal>
        <Title>My Skills</Title>
        <Title range />
      </Container>
      <Wrapper content>
        <Wrapper column colLeft reveal>
          <Title content>My Skills and Experiences</Title>
          <Desc>
            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quas neque quam quidem!
            Excepturi, ab perferendis quos repudiandae blanditiis totam sequi laborum ea modi
            dolores rem minima consectetur voluptates, officiis molestias veniam nesciunt, harum
            impedit. Maiores amet nisi consequatur, voluptate eius, impedit accusamus odio ipsum
          </Desc>
          <Button>See more</Button>
        </Wrapper>
        <Wrapper column colRight reveal>
          <Wrapper bar>
            <Wrapper info>
              <Title span>HTML</Title>
              <Title span>95%</Title>
            </Wrapper>
            <Wrapper progress lineHtml html></Wrapper>
          </Wrapper>
          <Wrapper bar>
            <Wrapper info>
              <Title span>CSS</Title>
              <Title span>95%</Title>
            </Wrapper>
            <Wrapper lineCss css></Wrapper>
          </Wrapper>
          <Wrapper bar>
            <Wrapper info>
              <Title span>JavaScript</Title>
              <Title progress span>
                80%
              </Title>
            </Wrapper>
            <Wrapper lineJs javaScript></Wrapper>
          </Wrapper>
          <Wrapper bar>
            <Wrapper info>
              <Title span>React</Title>
              <Title progress span>
                80%
              </Title>
            </Wrapper>
            <Wrapper lineReact react></Wrapper>
          </Wrapper>
        </Wrapper>
      </Wrapper>
    </Container>
  );
};
export default Skills;
